import domain from './domain';

/**
 * 开发环境
 */
const dev = {
  //cookie顶域
  DOMAIN: window.location.hostname,
  //api
  API_V2_URL: 'https://hitpaw-test-api.afirstsoft.cn/api/v2/',
};

/**
 * 测试环境  现阶段test和dev还没有区分，测试走的dev分支，后续区分了再在这里调整，调整的时候别忘了换url
 */
// const test = {
//   //cookie顶域
//   DOMAIN: window.location.hostname,
//   //api
//   API_V2_URL: "https://hitpaw-test-api.afirstsoft.cn/api/v2/",
// };

/**
 * 生产环境
 */
const prod = {
  //cookie顶域
  DOMAIN: domain,
  //api
  API_V2_URL: 'https://api.hitpaw.com/api/v2/',
};

let common =
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_BUILD_ENV === 'development'
    ? dev
    : prod;

/*
dockerdev
dockertest
dockerprod
dockerstage
dockeruat
*/
console.log(
  'REACT_APP_BUILD_ENV_DOCKER',
  process.env.REACT_APP_BUILD_ENV_DOCKER
);
let ENVdocker = process.env.REACT_APP_BUILD_ENV_DOCKER;
if (ENVdocker === 'dockerdev') {
  let dockerdev = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-dev-api.afirstsoft.cn/api/v2/',
  };
  common = dockerdev;
}
if (ENVdocker === 'dockertest') {
  let dockertest = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-test-api-docker.afirstsoft.cn/api/v2/',
  };
  common = dockertest;
}
if (ENVdocker === 'dockerstage') {
  let dockerstage = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-stage-api.afirstsoft.cn/api/v2/',
  };
  common = dockerstage;
}
if (ENVdocker === 'dockeruat') {
  let dockeruat = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-uat-api.afirstsoft.cn/api/v2/',
  };
  common = dockeruat;
}
if (ENVdocker === 'dockerprod') {
  let dockerprod = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-prod-api.afirstsoft.cn/api/v2/',
  };
  common = dockerprod;
}
const versionTest = '5.8.0.8';
const versionProd = '3.2.4';
export const version =
  process.env.REACT_APP_BUILD_ENV === 'production' ? versionProd : versionTest;
console.log('测试版本号', versionTest);

export default common;
